import React, { useEffect, useState } from 'react'
import { BiCog, BiMapPin } from "react-icons/bi";
import { Spinner } from 'react-bootstrap-v5';
import { HiOutlineTruck } from "react-icons/hi";
// import { GoReport } from "react-icons/go";
import { AiOutlineFileText } from "react-icons/ai";
import { RiSuitcaseLine, RiStore2Line } from "react-icons/ri";
// import MyResponsiveBar from './Charts/BarChart'
import PickupProgress from "./Charts/PickupProgress"
import MyResponsiveBar from "./Charts/BarChart"
import { Link } from "react-router-dom"
import './Dashboard.css';

import masterService from '../Services/masterService'
import CheckAccess from '../Function/CheckAccess';

export const Dashboard = () => {
    const [dashbaordCount, setDashbaordCount] = useState({})
    const [monthlyJobs, setMonthlyJobs] = useState([])
    const [monthlyPickup, setMonthlyPickup] = useState([])
    const [jobsLoader, setJobsLoader] = useState(false)
    const [pickupLoader, setPickupLoader] = useState(false)

    const getAllPrevMonth = () => {
        let monthList = [];
        const months = ["Jan","Feb","Mar","Apr","May","June","July","Aug","Sept","Oct","Nov","Dec"]
        const today = new Date()
        for (let i = 0; i < 12; i++) {
          const monthIndex = today.getMonth() - i;
          if (today.getMonth() - i >= 0) {
            var year =
              today.getFullYear() - Math.floor((today.getMonth() - i) / 12);
          } else {
            var year =
              today.getFullYear() - Math.floor((i - today.getMonth()) / 12);
          }
          const date = new Date(year, monthIndex, 2);
          monthList.push(months[date.getMonth()]);
        }
        return monthList.reverse()
    }
    let prevMonths = getAllPrevMonth()

    const getMonthlyJobs = async () => {
        setJobsLoader(true)
        await masterService.getMonthlyJobsData().then((res) => {
            if(res?.status){
                let data = Object.values(res.data).map((item,index) => {
                    item = {...item, ['MONTH']:prevMonths[index],
                }
                return item
            })
            setJobsLoader(false)
            setMonthlyJobs(data.reverse())
            }else{
            setJobsLoader(false)
            }
        })
    }

    const getMonthlyPickup = async () => {
        setPickupLoader(true)
        await masterService.getMonthlyPickupData().then((res) => {
            if(res?.status){
                let data = Object.keys(res.data).map((item) => {
                    item = {['label']:item.toUpperCase(), ['id']:item.toUpperCase(), ['value']: res.data[item] }
                    return item
                })
                setPickupLoader(false)
                setMonthlyPickup(data)
            }else{
                setPickupLoader(false)
            }
        })
    }

    const getData = async () => {
        await masterService.get_dashabord().then((result) => {
            if (result?.status === true) {
                setDashbaordCount(result.data)
            }
        });
        getMonthlyJobs()
        getMonthlyPickup()

    }

    useEffect(() => {
        getData()
    }, []);

    return (
        <div className="container-fluid">
            <div className="row dashboard_sec">
                <div className="col-md-6 col-xl-3">
                    <div className="card dash-card-crm">
                        <Link to={CheckAccess(411,"view") ? '/enquiry-management-c-r-m-list' : "#"} className="stretched-link"> </Link>
                        <div className="card-body d-flex">
                            <div className="float-end mt-2">
                                <div id="total-revenue-chart" />
                            </div>

                            <div className="flex-grow-1 pl-3">
                                <h4 className="mb-1 mt-1"><span className="dashboard_count" data-plugin="counterup">{dashbaordCount.quoteCount}</span></h4>
                                <p className="mb-0">CRM(Inquiries)</p>
                            </div>
                            <div className="dashboard_icons"><BiCog /></div>
                            {/* <p className="text-muted mt-3 mb-0"><span className="text-success me-1"><i className="mdi mdi-arrow-up-bold me-1" />2.65%</span> since last week */}
                            {/* </p> */}
                        </div>
                    </div>
                </div> {/* end col*/}
                <div className="col-md-6 col-xl-3">
                    <div className="card dash-card-pickup">
                        <Link to={CheckAccess(44,"view") ? '/pick-up-list' : "#"} className="stretched-link"> </Link>

                        <div className="card-body d-flex">
                            <div className="float-end mt-2">
                                <div id="orders-chart"> </div>
                            </div>
                            <div className="flex-grow-1">
                                <h4 className="mb-1 mt-1"><span className="dashboard_count" data-plugin="counterup">{dashbaordCount.pickUpCount}</span></h4>
                                <p className="mb-0">Pickup Updates</p>
                            </div>
                            <div className="dashboard_icons"><HiOutlineTruck /></div>

                        </div>
                    </div>
                </div>
                <div className="col-md-6 col-xl-3">
                    <div className="card dash-card-tracking">
                        <Link to={CheckAccess(45,"view") ? "/tracking-list" : "#"} className="stretched-link"> </Link>

                        <div className="card-body d-flex">
                            <div className="float-end mt-2">
                                <div id="customers-chart"> </div>
                            </div>
                            <div className="flex-grow-1">
                                <h4 className="mb-1 mt-1"><span className="dashboard_count" data-plugin="counterup">{dashbaordCount.trackingCount}</span></h4>
                                <p className="mb-0">Tracking Updates</p>
                            </div>
                            <div className="dashboard_icons"><BiMapPin /></div>

                        </div>
                    </div>
                </div>

                
                {/* <div className="col-md-6 col-xl-3">
                    <div className="card blue_bg">
                        <div className="card-body d-flex">
                            <div className="float-end mt-2">
                                <div id="total-revenue-chart" />
                            </div>
                            <div className="flex-grow-1">
                                <h4 className="mb-1 mt-1 text-white"><span className="dashboard_count" data-plugin="counterup">34,152</span></h4>
                                <p className="text-white mb-0">Reports</p>
                            </div>
                            <div className="dashboard_icons"><AiOutlineFileText /></div>
                        </div>
                    </div>
                </div> */}
                <div className="col-md-6 col-xl-3">
                    <div className="card dash-card-jobs">
                        <Link to={CheckAccess(412,"view") ? '/job-list' : '#'} className="stretched-link"> </Link>

                        <div className="card-body d-flex">
                            <div className="float-end mt-2">
                                <div id="total-revenue-chart" />
                            </div>
                            <div className="flex-grow-1">
                                <h4 className="mb-1 mt-1"><span className="dashboard_count" data-plugin="counterup">{dashbaordCount.jobCount}</span></h4>
                                <p className="mb-0">Jobs</p>
                            </div>
                            <div className="dashboard_icons"><RiSuitcaseLine /></div>
                            {/* <p className="text-muted mt-3 mb-0"><span className="text-success me-1"><i className="mdi mdi-arrow-up-bold me-1" />2.65%</span> since last week */}
                            {/* </p> */}
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12 mb-4">
                        <div className="dashboard-chart-card h-100">
                            <h4 className="chart-title">Monthly Jobs</h4>
                            <div style={{ height: '550px' }}>
                            {!jobsLoader ?
                            (monthlyJobs && monthlyJobs.length > 0 && 
                                <MyResponsiveBar monthlyJobs={monthlyJobs} />
                        || 
                            <div className='chart-loader-container'>
                            Data Not Available</div>)
                            :                 
                            <div className='chart-loader-container' ><Spinner
                            as="span"
                            animation="border"
                            size="sx"
                            role="status"
                            aria-hidden="true"
                        /></div>
                            }
                            </div>
                        </div>
                    </div>
                    <div className="col-md-12 mb-4">
                        <div className="dashboard-chart-card h-100">
                            <h4 className="chart-title">Monthly Pickup</h4>
                            <div style={{ height: '350px' }}>
                                {!pickupLoader ?
                               ( monthlyPickup && monthlyPickup.length > 0 &&
                                <PickupProgress monthlyPickup={monthlyPickup} />
                            || 
                                <div className='chart-loader-container'>
                                    Data Not Available</div>)
                                :   
                                <div className='chart-loader-container' ><Spinner
                                as="span"
                                animation="border"
                                size="sx"
                                role="status"
                                aria-hidden="true"
                                /> </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div> {/* end row*/}
            {/*           
            <div className="row">
                <div className="col-xl-4">
                    <div className="card">
                        <div className="card-body">
                            <div className="float-end">
                                <div className="dropdown">
                                    <a className=" dropdown-toggle" href="#" id="dropdownMenuButton2" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        <span className="text-muted">All Members<i className="mdi mdi-chevron-down ms-1" /></span>
                                    </a>
                                    <div className="dropdown-menu dropdown-menu-end" aria-labelledby="dropdownMenuButton2">
                                        <a className="dropdown-item" href="#">Locations</a>
                                        <a className="dropdown-item" href="#">Revenue</a>
                                        <a className="dropdown-item" href="#">Join Date</a>
                                    </div>
                                </div>
                            </div>
                            <h4 className="card-title mb-4">Top Users</h4>
                            <div data-simplebar style={{ maxHeight: '336px' }}>
                                <div className="table-responsive">
                                    <table className="table table-borderless table-centered table-nowrap">
                                        <tbody>
                                            <tr>
                                                <td style={{ width: '20px' }}><img src="/admin/assets/images/users/avatar-4.jpg" className="avatar-xs rounded-circle " alt="..." /></td>
                                                <td>
                                                    <h6 className="font-size-15 mb-1 fw-normal">Glenn Holden</h6>
                                                    <p className="text-muted font-size-13 mb-0"><i className="mdi mdi-map-marker" /> Nevada</p>
                                                </td>
                                                <td><span className="badge bg-soft-danger font-size-12">Cancel</span></td>
                                                <td className="text-muted fw-semibold text-end"><i className="icon-xs icon me-2 text-success" data-feather="trending-up" />$250.00</td>
                                            </tr>
                                            <tr>
                                                <td><img src="/admin/assets/images/users/avatar-5.jpg" className="avatar-xs rounded-circle " alt="..." /></td>
                                                <td>
                                                    <h6 className="font-size-15 mb-1 fw-normal">Lolita Hamill</h6>
                                                    <p className="text-muted font-size-13 mb-0"><i className="mdi mdi-map-marker" /> Texas</p>
                                                </td>
                                                <td><span className="badge bg-success font-size-12">Success</span></td>
                                                <td className="text-muted fw-semibold text-end"><i className="icon-xs icon me-2 text-danger" data-feather="trending-down" />$110.00</td>
                                            </tr>
                                            <tr>
                                                <td><img src="/admin/assets/images/users/avatar-6.jpg" className="avatar-xs rounded-circle " alt="..." /></td>
                                                <td>
                                                    <h6 className="font-size-15 mb-1 fw-normal">Robert Mercer</h6>
                                                    <p className="text-muted font-size-13 mb-0"><i className="mdi mdi-map-marker" /> California</p>
                                                </td>
                                                <td><span className="badge bg-soft-info font-size-12">Active</span></td>
                                                <td className="text-muted fw-semibold text-end"><i className="icon-xs icon me-2 text-success" data-feather="trending-up" />$420.00</td>
                                            </tr>
                                            <tr>
                                                <td><img src="/admin/assets/images/users/avatar-7.jpg" className="avatar-xs rounded-circle " alt="..." /></td>
                                                <td>
                                                    <h6 className="font-size-15 mb-1 fw-normal">Marie Kim</h6>
                                                    <p className="text-muted font-size-13 mb-0"><i className="mdi mdi-map-marker" /> Montana</p>
                                                </td>
                                                <td><span className="badge bg-soft-warning font-size-12">Pending</span></td>
                                                <td className="text-muted fw-semibold text-end"><i className="icon-xs icon me-2 text-danger" data-feather="trending-down" />$120.00</td>
                                            </tr>
                                            <tr>
                                                <td><img src="/admin/assets/images/users/avatar-8.jpg" className="avatar-xs rounded-circle " alt="..." /></td>
                                                <td>
                                                    <h6 className="font-size-15 mb-1 fw-normal">Sonya Henshaw</h6>
                                                    <p className="text-muted font-size-13 mb-0"><i className="mdi mdi-map-marker" /> Colorado</p>
                                                </td>
                                                <td><span className="badge bg-soft-info font-size-12">Active</span></td>
                                                <td className="text-muted fw-semibold text-end"><i className="icon-xs icon me-2 text-success" data-feather="trending-up" />$112.00</td>
                                            </tr>
                                            <tr>
                                                <td><img src="/admin/assets/images/users/avatar-2.jpg" className="avatar-xs rounded-circle " alt="..." /></td>
                                                <td>
                                                    <h6 className="font-size-15 mb-1 fw-normal">Marie Kim</h6>
                                                    <p className="text-muted font-size-13 mb-0"><i className="mdi mdi-map-marker" /> Australia</p>
                                                </td>
                                                <td><span className="badge bg-success font-size-12">Success</span></td>
                                                <td className="text-muted fw-semibold text-end"><i className="icon-xs icon me-2 text-danger" data-feather="trending-down" />$120.00</td>
                                            </tr>
                                            <tr>
                                                <td><img src="/admin/assets/images/users/avatar-1.jpg" className="avatar-xs rounded-circle " alt="..." /></td>
                                                <td>
                                                    <h6 className="font-size-15 mb-1 fw-normal">Sonya Henshaw</h6>
                                                    <p className="text-muted font-size-13 mb-0"><i className="mdi mdi-map-marker" /> India</p>
                                                </td>
                                                <td><span className="badge bg-soft-danger font-size-12">Cancel</span></td>
                                                <td className="text-muted fw-semibold text-end"><i className="icon-xs icon me-2 text-success" data-feather="trending-up" />$112.00</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div> 
                        </div>
                    </div> 
                </div>
                <div className="col-xl-4">
                    <div className="card">
                        <div className="card-body">
                            <div className="float-end">
                                <div className="dropdown">
                                    <a className="dropdown-toggle" href="#" id="dropdownMenuButton3" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        <span className="text-muted">Recent<i className="mdi mdi-chevron-down ms-1" /></span>
                                    </a>
                                    <div className="dropdown-menu dropdown-menu-end" aria-labelledby="dropdownMenuButton3">
                                        <a className="dropdown-item" href="#">Recent</a>
                                        <a className="dropdown-item" href="#">By Users</a>
                                    </div>
                                </div>
                            </div>
                            <h4 className="card-title mb-4">Recent Activity</h4>
                            <ol className="activity-feed mb-0 ps-2" data-simplebar style={{ maxHeight: '336px' }}>
                                <li className="feed-item">
                                    <div className="feed-item-list">
                                        <p className="text-muted mb-1 font-size-13">Today<small className="d-inline-block ms-1">12:20 pm</small></p>
                                        <p className="mt-0 mb-0">Andrei Coman magna sed porta finibus, risus
                              posted a new article: <span className="text-primary">Forget UX
                                Rowland</span></p>
                                    </div>
                                </li>
                                <li className="feed-item">
                                    <p className="text-muted mb-1 font-size-13">22 Jul, 2020 <small className="d-inline-block ms-1">12:36 pm</small></p>
                                    <p className="mt-0 mb-0">Andrei Coman posted a new article: <span className="text-primary">Designer Alex</span></p>
                                </li>
                                <li className="feed-item">
                                    <p className="text-muted mb-1 font-size-13">18 Jul, 2020 <small className="d-inline-block ms-1">07:56 am</small></p>
                                    <p className="mt-0 mb-0">Zack Wetass, sed porta finibus, risus Chris Wallace
                            Commented <span className="text-primary"> Developer Moreno</span></p>
                                </li>
                                <li className="feed-item">
                                    <p className="text-muted mb-1 font-size-13">10 Jul, 2020 <small className="d-inline-block ms-1">08:42 pm</small></p>
                                    <p className="mt-0 mb-0">Zack Wetass, Chris combined Commented <span className="text-primary">UX Murphy</span></p>
                                </li>
                                <li className="feed-item">
                                    <p className="text-muted mb-1 font-size-13">23 Jun, 2020 <small className="d-inline-block ms-1">12:22 am</small></p>
                                    <p className="mt-0 mb-0">Zack Wetass, sed porta finibus, risus Chris Wallace
                            Commented <span className="text-primary"> Developer Moreno</span></p>
                                </li>
                                <li className="feed-item pb-1">
                                    <p className="text-muted mb-1 font-size-13">20 Jun, 2020 <small className="d-inline-block ms-1">09:48 pm</small></p>
                                    <p className="mt-0 mb-0">Zack Wetass, Chris combined Commented <span className="text-primary">UX Murphy</span></p>
                                </li>
                            </ol>
                        </div>
                    </div>
                </div>
                <div className="col-xl-4">
                    <div className="card">
                        <div className="card-body">
                            <div className="float-end">
                                <div className="dropdown">
                                    <a className="dropdown-toggle" href="#" id="dropdownMenuButton4" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        <span className="text-muted">Monthly<i className="mdi mdi-chevron-down ms-1" /></span>
                                    </a>
                                    <div className="dropdown-menu dropdown-menu-end" aria-labelledby="dropdownMenuButton4">
                                        <a className="dropdown-item" href="#">Yearly</a>
                                        <a className="dropdown-item" href="#">Monthly</a>
                                        <a className="dropdown-item" href="#">Weekly</a>
                                    </div>
                                </div>
                            </div>
                            <h4 className="card-title">Social Source</h4>
                            <div className="text-center">
                                <div className="avatar-sm mx-auto mb-4">
                                    <span className="avatar-title rounded-circle bg-soft-primary font-size-24">
                                        <i className="mdi mdi-facebook text-primary" />
                                    </span>
                                </div>
                                <p className="font-16 text-muted mb-2" />
                                <h5><a href="#" className="text-dark">Facebook - <span className="text-muted font-16">125 sales</span> </a></h5>
                                <p className="text-muted">Maecenas nec odio et ante tincidunt tempus. Donec vitae sapien ut libero venenatis faucibus tincidunt.</p>
                                <a href="#" className="text-reset font-16">Learn more <i className="mdi mdi-chevron-right" /></a>
                            </div>
                            <div className="row mt-4">
                                <div className="col-4">
                                    <div className="social-source text-center mt-3">
                                        <div className="avatar-xs mx-auto mb-3">
                                            <span className="avatar-title rounded-circle bg-primary font-size-16">
                                                <i className="mdi mdi-facebook text-white" />
                                            </span>
                                        </div>
                                        <h5 className="font-size-15">Facebook</h5>
                                        <p className="text-muted mb-0">125 sales</p>
                                    </div>
                                </div>
                                <div className="col-4">
                                    <div className="social-source text-center mt-3">
                                        <div className="avatar-xs mx-auto mb-3">
                                            <span className="avatar-title rounded-circle bg-info font-size-16">
                                                <i className="mdi mdi-twitter text-white" />
                                            </span>
                                        </div>
                                        <h5 className="font-size-15">Twitter</h5>
                                        <p className="text-muted mb-0">112 sales</p>
                                    </div>
                                </div>
                                <div className="col-4">
                                    <div className="social-source text-center mt-3">
                                        <div className="avatar-xs mx-auto mb-3">
                                            <span className="avatar-title rounded-circle bg-pink font-size-16">
                                                <i className="mdi mdi-instagram text-white" />
                                            </span>
                                        </div>
                                        <h5 className="font-size-15">Instagram</h5>
                                        <p className="text-muted mb-0">104 sales</p>
                                    </div>
                                </div>
                            </div>
                            <div className="mt-3 text-center">
                                <a href="#" className="text-primary font-size-14 fw-medium">View All Sources <i className="mdi mdi-chevron-right" /></a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
           */}
            {/* end row */}
            {/*        
            <div className="row">
                <div className="col-lg-12">
                    <div className="card">
                        <div className="card-body">
                            <h4 className="card-title mb-4">Latest Transaction</h4>
                            <div className="table-responsive">
                                <table className="table table-centered table-nowrap mb-0">
                                    <thead className="table-light">
                                        <tr>
                                            <th style={{ width: '20px' }}>
                                                <div className="form-check font-size-16">
                                                    <input type="checkbox" className="form-check-input" id="customCheck1" />
                                                    <label className="form-check-label" htmlFor="customCheck1">&nbsp;</label>
                                                </div>
                                            </th>
                                            <th>Order ID</th>
                                            <th>Billing Name</th>
                                            <th>Date</th>
                                            <th>Total</th>
                                            <th>Payment Status</th>
                                            <th>Payment Method</th>
                                            <th>View Details</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>
                                                <div className="form-check font-size-16">
                                                    <input type="checkbox" className="form-check-input" id="customCheck2" />
                                                    <label className="form-check-label" htmlFor="customCheck2">&nbsp;</label>
                                                </div>
                                            </td>
                                            <td><a href="javascript: void(0);" className="text-body fw-bold">#MB2540</a> </td>
                                            <td>Neal Matthews</td>
                                            <td>
                                                07 Oct, 2019
                              </td>
                                            <td>
                                                $400
                              </td>
                                            <td>
                                                <span className="badge rounded-pill bg-success font-size-12">Paid</span>
                                            </td>
                                            <td>
                                                <i className="fab fa-cc-mastercard me-1" /> Mastercard
                              </td>
                                            <td>
                                                <button type="button" className="btn btn-primary btn-sm btn-rounded waves-effect waves-light">
                                                    View Details
                                </button>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <div className="form-check font-size-16">
                                                    <input type="checkbox" className="form-check-input" id="customCheck3" />
                                                    <label className="form-check-label" htmlFor="customCheck3">&nbsp;</label>
                                                </div>
                                            </td>
                                            <td><a href="javascript: void(0);" className="text-body fw-bold">#MB2541</a> </td>
                                            <td>Jamal Burnett</td>
                                            <td>
                                                07 Oct, 2019
                              </td>
                                            <td>
                                                $380
                              </td>
                                            <td>
                                                <span className="badge rounded-pill bg-soft-danger font-size-12">Chargeback</span>
                                            </td>
                                            <td>
                                                <i className="fab fa-cc-visa me-1" /> Visa
                              </td>
                                            <td>
                                                <button type="button" className="btn btn-primary btn-sm btn-rounded waves-effect waves-light">
                                                    View Details
                                </button>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <div className="form-check font-size-16">
                                                    <input type="checkbox" className="form-check-input" id="customCheck4" />
                                                    <label className="form-check-label" htmlFor="customCheck4">&nbsp;</label>
                                                </div>
                                            </td>
                                            <td><a href="javascript: void(0);" className="text-body fw-bold">#MB2542</a> </td>
                                            <td>Juan Mitchell</td>
                                            <td>
                                                06 Oct, 2019
                              </td>
                                            <td>
                                                $384
                              </td>
                                            <td>
                                                <span className="badge rounded-pill bg-success font-size-12">Paid</span>
                                            </td>
                                            <td>
                                                <i className="fab fa-cc-paypal me-1" /> Paypal
                              </td>
                                            <td>
                                                <button type="button" className="btn btn-primary btn-sm btn-rounded waves-effect waves-light">
                                                    View Details
                                </button>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <div className="form-check font-size-16">
                                                    <input type="checkbox" className="form-check-input" id="customCheck5" />
                                                    <label className="form-check-label" htmlFor="customCheck5">&nbsp;</label>
                                                </div>
                                            </td>
                                            <td><a href="javascript: void(0);" className="text-body fw-bold">#MB2543</a> </td>
                                            <td>Barry Dick</td>
                                            <td>
                                                05 Oct, 2019
                              </td>
                                            <td>
                                                $412
                              </td>
                                            <td>
                                                <span className="badge rounded-pill bg-success font-size-12">Paid</span>
                                            </td>
                                            <td>
                                                <i className="fab fa-cc-mastercard me-1" /> Mastercard
                              </td>
                                            <td>
                                                <button type="button" className="btn btn-primary btn-sm btn-rounded waves-effect waves-light">
                                                    View Details
                                </button>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <div className="form-check font-size-16">
                                                    <input type="checkbox" className="form-check-input" id="customCheck6" />
                                                    <label className="form-check-label" htmlFor="customCheck6">&nbsp;</label>
                                                </div>
                                            </td>
                                            <td><a href="javascript: void(0);" className="text-body fw-bold">#MB2544</a> </td>
                                            <td>Ronald Taylor</td>
                                            <td>
                                                04 Oct, 2019
                              </td>
                                            <td>
                                                $404
                              </td>
                                            <td>
                                                <span className="badge rounded-pill bg-soft-warning font-size-12">Refund</span>
                                            </td>
                                            <td>
                                                <i className="fab fa-cc-visa me-1" /> Visa
                              </td>
                                            <td>
                                                <button type="button" className="btn btn-primary btn-sm btn-rounded waves-effect waves-light">
                                                    View Details
                                </button>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <div className="form-check font-size-16">
                                                    <input type="checkbox" className="form-check-input" id="customCheck7" />
                                                    <label className="form-check-label" htmlFor="customCheck7">&nbsp;</label>
                                                </div>
                                            </td>
                                            <td><a href="javascript: void(0);" className="text-body fw-bold">#MB2545</a> </td>
                                            <td>Jacob Hunter</td>
                                            <td>
                                                04 Oct, 2019
                              </td>
                                            <td>
                                                $392
                              </td>
                                            <td>
                                                <span className="badge rounded-pill bg-success font-size-12">Paid</span>
                                            </td>
                                            <td>
                                                <i className="fab fa-cc-paypal me-1" /> Paypal
                              </td>
                                            <td>
                                                <button type="button" className="btn btn-primary btn-sm btn-rounded waves-effect waves-light">
                                                    View Details
                                </button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        */}
        </div>
    );
}